import { useTranslation } from 'react-i18next';
import Method from './Method';
import { UserModule } from '../api/methodsApi';
import Alert from '@pelckmans/elementis/components/alert';
import Blockheader from '@pelckmans/elementis/components/blockheader';

export function MethodList({
  groupedModules,
  phasedOutModules,
  visitedModules,
  addedModuleIds,
}: {
  groupedModules: { years: number[]; modules: UserModule[] }[];
  phasedOutModules: { years: number[]; modules: UserModule[] }[];
  visitedModules: string[];
  addedModuleIds: string[];
}) {
  const { t } = useTranslation();
  return (
    <>
      <section
        className="active-modules modules-container"
        aria-label={t('PAGES.MY_METHODS.REGION.MODULES.A11Y_LABEL')}
      >
        {groupedModules?.map(({ years, modules }) =>
          modules.map((module, index: number) => {
            return (
              <Method
                key={module.id}
                module={module}
                position={index}
                visitedModules={visitedModules}
                years={years}
                isNew={addedModuleIds.includes(module.id)}
                scrollTo={addedModuleIds[0] === module.id}
              />
            );
          }),
        )}
      </section>
      {phasedOutModules.length > 0 && (
        <section className="phased-out-modules" aria-labelledby="phased-out-heading">
          <Blockheader
            id="phased-out-heading"
            title={t('PAGES.MY_METHODS.REGION.PHASED_OUT_MODULES.TITLE')}
            titleTag="h2"
            alert={<Alert prominence="warning">{t('PAGES.MY_METHODS.REGION.PHASED_OUT_MODULES.ALERT.MESSAGE')}</Alert>}
          />
          <div className="modules-container">
            {phasedOutModules?.map(({ years, modules }) =>
              modules.map((module, index) => (
                <Method
                  key={module.id}
                  module={module}
                  position={index}
                  visitedModules={visitedModules}
                  years={years}
                  isNew={addedModuleIds.includes(module.id)}
                  scrollTo={addedModuleIds[0] === module.id}
                />
              )),
            )}
          </div>
        </section>
      )}
    </>
  );
}
